/**
 * Chip — the small rounded secondary button (`.mark-chip` in mark-skin.css).
 *
 * All of the look lives in the class; this only stops each caller re-typing
 * `type="button" class="mark-chip"`. Everything else (testid, aria-pressed,
 * disabled, an extra class, a one-off inline style) passes straight through.
 */
import type { JSX } from "preact";

export type ChipProps = Omit<JSX.HTMLAttributes<HTMLButtonElement>, "type">;

export function Chip({ class: extraClass, className, ...rest }: ChipProps) {
  const extra = extraClass ?? className;
  return <button type="button" {...rest} class={extra ? `mark-chip ${extra}` : "mark-chip"} />;
}
